export default __webpack_public_path__ + "static/media/web_super_engaged.0254f60c.svg";